import { useEffect, useState } from "react";
import { Product } from "../types/Product";

export function useProducts() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const productsUrl =
    "https://equalexperts.github.io/frontend-take-home-test-data/products.json";

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(productsUrl);
        if (!response.ok) throw new Error("Failed to fetch products.");
        const data = await response.json();
        setProducts(data);
        setLoading(false);
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : "An error occured.");
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return { products, loading, error };
}
